'use client'
import { getVersionForClone } from '@qr-front/ui/utils'

import { BaseGeneratorHeader } from './BaseGeneratorHeader'
import { Clone1GeneratorHeader } from './Clone1GeneratorHeader'

export const GeneratorHeader = getVersionForClone({
	base: BaseGeneratorHeader,
	clone1: Clone1GeneratorHeader,
})
